import type { CustomerOption, ExceptionField } from '@/api/cockpit';
import { resolveMatchedFieldValue } from './resolve-matched-field-value';

export function resolveMatchedCustomerDisplay(
  field: ExceptionField,
  catalogOptions: readonly CustomerOption[],
  fields: Record<string, string>,
): string {
  const value = resolveMatchedFieldValue(field, fields);
  if (!value) return '';
  const candidate = field.matchedCandidates?.find((row) => row.value === value);
  if (candidate) return candidate.label;
  const option = catalogOptions.find((row) => row.customerNumber === value);
  return option?.display ?? field.matchedDisplayValue ?? value;
}
